import { NotificationIcons, UserNotificationType } from '@tableau/user-notifications-client-core';
import React from 'react';

import { UserProfilePicture } from '../../app/content/UserProfilePicture';
import * as styles from '../styles/notificationStyles';

const svgDataUriRegExp: RegExp = /^data\:image\/svg\+xml/;

export interface NotificationIconProps {
  notificationType: UserNotificationType;
  displayName: string;
  imageUrl: string;
}

export class NotificationIcon extends React.PureComponent<NotificationIconProps> {

  public render(): JSX.Element {

    const secondImageUrl = this.getSecondImageUrl();

    return (
      <div style={styles.profileImageContainer}>
        <UserProfilePicture
          profileDisplayName={this.props.displayName}
          imageUrl={this.getMainImageUrl()}
          imageSize={styles.userProfileSize}
          fontSize={styles.userProfileTextSize} />
        {secondImageUrl && <div className='profile-second-image' style={styles.userProfileSecondImage(secondImageUrl)} />}
      </div>
    );
  }

  // Used encoding from https://gitlab.tableausoftware.com/browser-clients/widgets/-/blob/master/src/icons/Icons.ts
  private encodeSvg(svg: string): string {
    return svgDataUriRegExp.test(svg) ? svg : `data:image/svg+xml,${encodeURIComponent(svg)}`;
  }

  private getMainImageUrl(): string {
    if (NotificationIcons[this.props.notificationType]?.systemSvg) {
      return this.encodeSvg(NotificationIcons[this.props.notificationType].systemSvg);
    } else {
      return this.props.imageUrl;
    }
  }

  private getSecondImageUrl(): string {
    if (NotificationIcons[this.props.notificationType]?.secondSvg)
      return this.encodeSvg(NotificationIcons[this.props.notificationType].secondSvg);
    else {
      return '';
    }
  }
}